// Página a la que volver después de iniciar sesión, para la autorización de OAuth: Claude.ai o ChatGPT abren
// /oauth/authorize y, si no hay sesión, se pasa por el login. Solo se vuelve a rutas propias de OAuth.
const KEY = "afterLoginPath";

export const rememberReturnPath = (path) => {
    try { sessionStorage.setItem(KEY, path); } catch (error) { /* sin sessionStorage se vuelve al inicio */ }
};

export const takeReturnPath = () => {
    try {
        const path = sessionStorage.getItem(KEY);
        sessionStorage.removeItem(KEY);
        return path && path.startsWith("/oauth/") ? path : null;
    } catch (error) {
        return null;
    }
};
